import bookingPeriodRow from "./directive";
import BpResourceEntriesModule from "./bp-resource-entries/module";

const modul = angular
    .module("BookingPeriodRowsModule", [BpResourceEntriesModule])
    .directive("bookingPeriodRow", bookingPeriodRow);

export default modul.name;
